import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { RegionType } from '@src/slide/domain/selection/constant/region';


@Feature()
export class HideSlideFeature extends BaseMobileContextMenuFeature {
    public id = 'hide-slide';

    public hideSlides(): void {
        const selectedSlides = this.getSelectionService().selectedSlides.selectedArray;
        this.getAppServices().getUiDataService().presentation.toggleShowSlides(selectedSlides, false);
    }

    public showSlides(): void {
        const selectedSlides = this.getSelectionService().selectedSlides.selectedArray;
        this.getAppServices().getUiDataService().presentation.toggleShowSlides(selectedSlides, true);
    }

    public shouldHideHideSlideButton(): boolean {
        const isPreviewMode = !this.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode) {
            return true;
        }
        const { lastMouseDownRegion } = this.getSelectionService();
        if (lastMouseDownRegion !== RegionType.SLIDELIST) {
            return true;
        }
        const selectedSlides: ISlideModel[] = this.getSelectionService().selectedSlides.selectedArray;
        return selectedSlides.length > 0
            && this.isAllSelectedSlidesHidden(selectedSlides);
    }

    public shouldHideCancelHideSlideButton(): boolean {
        const isPreviewMode = !this.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode) {
            return true;
        }
        const { lastMouseDownRegion } = this.getSelectionService();
        if (lastMouseDownRegion !== RegionType.SLIDELIST) {
            return true;
        }
        const selectedSlides: ISlideModel[] = this.getSelectionService().selectedSlides.selectedArray;
        return selectedSlides.length > 0
            && !this.isAllSelectedSlidesHidden(selectedSlides);
    }

    private isAllSelectedSlidesHidden(selectedSlides: ISlideModel[]): boolean {
        return selectedSlides.every(slide => !slide.isShowInPlay);
    }
}
